var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description",class:{
    adjust: _vm.isAdjustDescription,
  }},[_c('p',[_vm._v("\n    レイアウトはイメージです。実際は細かな配置や文字サイズを整えた状態での仕上がりとなります。\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }